"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var myAccountChangeDetailsCtaStyles = makeStyles_1.default(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints, typography = _a.typography;
    return ({
        root: (_b = {
                position: 'absolute',
                right: 0,
                top: -55
            },
            _b[breakpoints.down('sm')] = {
                width: 'auto',
            },
            _b.justifyContent = 'flex-end',
            _b),
        text: {
            fontSize: typography.fontMD,
        },
    });
}, { name: 'Checkout4_ChangeDetailsCTA' });
exports.default = myAccountChangeDetailsCtaStyles;
